import moment from 'moment'

let interval
const START_AFTER_SECONDS = 5
const ACTUAL_PRICE = 100000
const MIN_BID_DEFINITION = 1000
const MY_LOGIN_CODE = '81TS1VDY'

const getAllAuctionBids = (monetization) => {
    return [
        {
            "id": "bid3",
            "date": moment(monetization.info.start.date).add(2, 'minutes').add(48, 'seconds').toISOString(),
            "who": '24ZN2GQR',
            "type": "applyWithoutPreEmption"
        },
        {
            "id": "bid2",
            "date": moment(monetization.info.start.date).add(1, 'minutes').add(38, 'seconds').toISOString(),
            "who": '24ZN2GQR',
            "type": "applyWithoutPreEmption"
        },
        {
            "id": "bid1",
            "date": moment(monetization.info.start.date).add(10, 'seconds').toISOString(),
            "who": '24ZN2GQR',
            "type": "applyWithoutPreEmption"
        }
    ]
}

const getOtherLogs = (monetization) => {
    return [
        {
            "id": "winningHit",
            date: moment(monetization.info.finish.date).subtract(1, 'milliseconds').toISOString(),
            "who": "licitátor",
            "type": "winningHit",
            "value": monetization.info.actualPrice,
            "text": null,
            "htmlText": `<span>Dra\u017eba byla ukon\u010dena. V\u00edt\u011bzem dra\u017eby se stal \u00fa\u010dastn\u00edk , jeho\u017e nejvy\u0161\u0161\u00ed pod\u00e1n\u00ed \u010din\u00ed\/\u010dinilo ${monetization.info.actualPrice} K\u010d.<\/span>`
        },
        {
            id: "preFinish",
            date: moment(monetization.info.finish.date).subtract(2, 'milliseconds').toISOString(),
            "type": "info",
            "value": monetization.info.actualPrice,
            "text": "online-auction-end@24ZN2GQR",
            "htmlText": `<span>Neu\u010din\u00ed-li n\u011bkdo z p\u0159\u00edtomn\u00fdch \u00fa\u010dastn\u00edk\u016f dra\u017eba pod\u00e1n\u00ed vy\u0161\u0161\u00ed, ne\u017e bylo pod\u00e1n\u00ed naposled u\u010din\u011bn\u00e9 \u00fa\u010dastn\u00edkem <strong>24ZN2GQR<\/strong>, ud\u011bl\u00edm mu p\u0159\u00edklep.<\/span>`

        },
        {
            "id": "left3",
            date: moment(monetization.info.finish.date).subtract(1, 'minutes').toISOString(),
            "who": "licitátor",
            "type": "info",
            "value": monetization.info.actualPrice,
            "text": "online-auction-1minutes-left@24ZN2GQR",
            "htmlText": `<span>Pod\u00e1n\u00ed ve v\u00fd\u0161i ${monetization.info.actualPrice},- K\u010d u\u010din\u011bn\u00e9 \u00fa\u010dastn\u00edkem dra\u017eby <strong>${monetization.info.currentWinner?.contact?.code}<\/strong> POT\u0158ET\u00cd!<\/span>`
        },
        {
            "id": "left2",
            date: moment(monetization.info.finish.date).subtract(2, 'minutes').toISOString(),
            "who": "licitátor",
            "type": "info",
            "value": monetization.info.actualPrice,
            "text": "online-auction-2minutes-left@24ZN2GQR",
            "htmlText": `<span>Pod\u00e1n\u00ed ve v\u00fd\u0161i ${monetization.info.actualPrice},- K\u010d u\u010din\u011bn\u00e9 \u00fa\u010dastn\u00edkem dra\u017eba <strong>${monetization.info.currentWinner?.contact?.code}<\/strong> PODRUH\u00c9!<\/span>`
        },
        {
            "id": "left1",
            "date": moment(monetization.info.finish.date).subtract(3, 'minutes').toISOString(),
            "who": "licitátor",
            "type": "info",
            "value": monetization.info.actualPrice,
            "text": "online-auction-3minutes-left@24ZN2GQR",
            "htmlText": `<span>Pod\u00e1n\u00ed ve v\u00fd\u0161i ${monetization.info.actualPrice},- K\u010d u\u010din\u011bn\u00e9 \u00fa\u010dastn\u00edkem dra\u017eba <strong>${monetization.info.currentWinner?.contact?.code}<\/strong> POPRV\u00c9!<\/span>`
        },
    ]
}

const createFakeBid = (monetization, bid) => {
    const newValue = monetization.info.actualPrice + monetization.info.minBidDefinition
    bid.value = newValue
    bid.htmlText = `<span>\u00da\u010dastn\u00edk <strong>${bid.who}<\/strong> u\u010dinil pod\u00e1n\u00ed <strong>${newValue},- ${monetization.info.currency.symbol}<\/strong><\/span>`
    return bid
}

export class FakeAuctionService {
    static async fetchMonetization(id) {
        const existMonetization = FakeAuctionService.getMonetizationFromLocalStorage()

        if (existMonetization) {
            return existMonetization
        }

        clearInterval(interval)

        const now = moment()
        const start = moment(now).add(START_AFTER_SECONDS, 'seconds')
        const finish = moment(start).add(5, 'minutes')

        const monetization =  {
            "id": "2ec111ec-a549-4730-a91d-ad9033c3f777",
            "preEmption": false,
            "type": "onlineAuction",
            "mode": null,
            "code": "TEST",
            "name": {
                "af01837f-aa5f-417e-bdfc-795f5f6c53cb": "TESTOVACÍ DRAŽBA"
            },
            "auctioneer": {
                "adminUser": {
                    "id": "e532aa11-cba2-4122-981b-c65a77022574",
                    "mail": "info@prokonzulta.cz",
                    "name": "Jan",
                    "surname": "Novák",
                    "phone": null
                }
            },
            "info": {
                "loginCode": MY_LOGIN_CODE,
                "cycle": null,
                "currentOffer": {
                    "priceAccepted": null,
                    "date": null
                },
                "lastOffer": {
                    "priceAccepted": null,
                    "date": null
                },
                "startingPrice": 100000,
                "auctionAdvance": 1000,
                "actualPrice": ACTUAL_PRICE,
                "minimumBid": ACTUAL_PRICE + MIN_BID_DEFINITION,
                "minBidDefinition": MIN_BID_DEFINITION,
                "start": {
                    "date": start.toISOString()
                },
                "finish": {
                    "date": finish.toISOString()
                },
                "currency": {
                    "id": "ed3c449c-b4a2-4ea1-8c66-9396cf1499bc",
                    "code": "203",
                    "symbol": "Kč"
                },
                "documents": [],
                "finished": false
            },
            "log": [
                {
                    "date": start.toISOString(),
                    "who": "robot",
                    "type": "info",
                    "value": 100000,
                    "text": "Dobr\u00fd den,<br>\nV\u00edt\u00e1m v\u00e1s na elektronick\u00e9 dra\u017eb\u011b dobrovoln\u00e9 Dra\u017ebice, kterou t\u00edmto zahajuji a pokra\u010duji vyvol\u00e1n\u00edm:<br><br>\nDra\u017eebn\u00edk:<br>\nPROKONZULTA, a.s., I\u010c 25332953, se s\u00eddlem K\u0159enov\u00e1 299\/26, 602 00 Brno<br>\nspole\u010dnost je zapsan\u00e1 v obchodn\u00edm rejst\u0159\u00edku u Krajsk\u00e9ho soudu v Brn\u011b, sp. zn.B 4298<br>\n<br>\nLicit\u00e1tor:<Br>\nPetr Kittel<br>\n<br>\nNavrhovatel:<Br>\n<br>\n<br>\nTerm\u00edn dra\u017eby:<br>\nZah\u00e1jen\u00ed: 16.11.2020 18:22:00<br>\nUkon\u010den\u00ed: 16.11.2020 18:27:00<br>\n<br>\nOzna\u010den\u00ed a specifikace p\u0159edm\u011btu dra\u017eby:<br>\n<p>Pozeme\u010dek na prodej<\/p><br>\n<br>\n\nOdhad ceny p\u0159edm\u011btu dra\u017eby:  0,- K\u010d<br>\nCenu zjistil znalec , znaleck\u00fd posudek \u010d\u00edslo  ze dne 21.9.2020<br>\n<br>\nNejni\u017e\u0161\u00ed pod\u00e1n\u00ed:       100000,- K\u010d<br>\nMinim\u00e1ln\u00ed p\u0159\u00edhoz:       1000,- K\u010d<br>\nDra\u017eebn\u00ed jistota:     1000,- K\u010d<br>\n<br>\nZ\u00e1stavn\u00ed pr\u00e1va, v\u011bcn\u00e1 b\u0159emena a dal\u0161\u00ed z\u00e1vazky v\u00e1znouc\u00ed na p\u0159edm\u011btu dra\u017eby:<br>\n\n<br>\n<br>\nVe\u0161ker\u00e9 podm\u00ednky a informace o dra\u017eb\u011b naleznete v <a href='http:\/\/www.centralniadresa.cz\/cadr\/download?znackaInzeratu=.' target='_blank'>dra\u017eebn\u00ed vyhl\u00e1\u0161ce<\/a>.<br>\n<br>\nVe\u0161ker\u00e9 informace o pou\u017e\u00edv\u00e1n\u00ed dra\u017eebn\u00edho syst\u00e9mu naleznete v <a href='http:\/\/www.prokonzulta.cz\/files\/Pruvodce_pro_ucast_v_elektronickych_drazbach.pdf' target='_blank'>pr\u016fvodci pro \u00fa\u010dast v elektronick\u00fdch dra\u017eb\u00e1ch<\/a>.<br>\n<br>\n\t\t\tT\u00edmto vyz\u00fdv\u00e1m \u00fa\u010dastn\u00edky dra\u017eby, aby u\u010dinili alespo\u0148 nejni\u017e\u0161\u00ed pod\u00e1n\u00ed!<br>",
                    "htmlText": "Dobrý den, vítejte v testovací dražbě"
                }
            ]
        }

        this.setMonetizationToLocalStorage(monetization)
        this.startTimer()
        return this.getMonetizationFromLocalStorage()
    }

    static startTimer() {
        interval = setInterval(() => {
            let monetizationChanged = false
            const monetization = FakeAuctionService.getMonetizationFromLocalStorage()
            const bidLogs = getAllAuctionBids(monetization)
            /** filter by already triggered logs **/
            const allowedBids = bidLogs.filter(l => !monetization.log.find(log => l.id === log.id))

            /**
             * make fake bid
             */
            for (const bid of allowedBids) {
                const now = moment()

                if (now.isAfter(moment(bid.date))) {
                    const updatedBid = createFakeBid(monetization, bid)
                    monetization.log.push(updatedBid)
                    monetization.info.actualPrice = updatedBid.value
                    monetization.info.currentWinner = {contact: {id: '1', code: updatedBid.who, iam: false}}
                    monetization.info.minimumBid = updatedBid.value + monetization.info.minBidDefinition
                    if (now.isAfter(moment(monetization.info.finish.date).subtract(3, 'minutes'))) {
                        monetization.info.finish.date = moment().add(5, 'minutes').toISOString()
                    }
                    monetizationChanged = true
                }
            }

            const otherLogs = getOtherLogs(monetization)
            const allowedOtherLogs = otherLogs
                .map(l => ({...l, id: l.id + l.date}))
                .filter(l => !monetization.log.find(log => l.id === log.id))

            for (const l of allowedOtherLogs) {
                const now = moment()
                if (now.isAfter(moment(l.date))) {
                    monetization.log.push(l)
                    monetizationChanged = true
                }
            }

            if (monetizationChanged) {
                this.setMonetizationToLocalStorage(monetization)
                Event.fire('refreshMonetization')
            }
        }, 1000)
    }

    static async bid(id, payload) {
        const monetization = FakeAuctionService.getMonetizationFromLocalStorage()

        monetization.info.actualPrice = payload.bid
        monetization.info.currentWinner = {contact: {id: '0', code: MY_LOGIN_CODE}, iam: true}
        monetization.info.minimumBid = payload.bid + monetization.info.minBidDefinition
        monetization.log.push({
            date: moment().toISOString(),
            who: MY_LOGIN_CODE,
            type: 'applyWithoutPreEmption',
            value: payload.bid,
            htmlText: `<span>\u00da\u010dastn\u00edk <strong>${MY_LOGIN_CODE}<\/strong> u\u010dinil pod\u00e1n\u00ed <strong>${payload.bid},- ${monetization.info.currency.symbol}<\/strong><\/span>`
        })

        const now = moment()
        if (now.isAfter(moment(monetization.info.finish.date).subtract(3, 'minutes'))) {
            monetization.info.finish.date = moment().add(5, 'minutes').toISOString()
        }
        this.setMonetizationToLocalStorage(monetization)
        return monetization
    }

    static setMonetizationToLocalStorage(monetization) {
        monetization.log = monetization.log.sort((a, b) => moment.utc(a.date).diff(moment.utc(b.date))).reverse()
        localStorage.setItem('testAuction', JSON.stringify(monetization))
    }

    static getMonetizationFromLocalStorage() {
        const monetization = localStorage.getItem('testAuction')
        return monetization ? JSON.parse(monetization) : null
    }
}
